import { MOVE_CONSTRAINTS, SNAP_GRIDS, type MoveConstraint, type SnapSettings } from '@rcs/editor';
import { ToolButton } from '@rcs/ui';
import { messages } from '../i18n/ja';

/** 制御点を移動するときの制約（軸固定・水平面固定・垂直方向固定）とグリッドスナップの設定。 */
export function MoveSettings({
  constraint,
  snap,
  onConstraintChange,
  onSnapChange,
}: {
  readonly constraint: MoveConstraint;
  readonly snap: SnapSettings;
  readonly onConstraintChange: (constraint: MoveConstraint) => void;
  readonly onSnapChange: (snap: SnapSettings) => void;
}) {
  const t = messages.move;
  return (
    <section className="move-settings" aria-label={t.title}>
      <h3 className="move-settings__title">{t.title}</h3>
      <div className="move-settings__group" role="group" aria-label={t.constraintGroup}>
        {MOVE_CONSTRAINTS.map((kind) => (
          <ToolButton
            key={kind}
            label={t.constraints[kind]}
            pressed={constraint === kind}
            onClick={() => {
              onConstraintChange(kind);
            }}
            data-testid={`constraint-${kind}`}
          />
        ))}
      </div>
      <div className="move-settings__snap">
        <ToolButton
          label={t.snap}
          pressed={snap.enabled}
          onClick={() => {
            onSnapChange({ ...snap, enabled: !snap.enabled });
          }}
          data-testid="snap-toggle"
        />
        <label className="move-settings__grid">
          <span>{t.grid}</span>
          <select
            value={snap.grid}
            data-testid="snap-grid"
            onChange={(event) => {
              onSnapChange({ ...snap, grid: Number(event.target.value) });
            }}
          >
            {SNAP_GRIDS.map((grid) => (
              <option key={grid} value={grid}>
                {`${String(grid)} m`}
              </option>
            ))}
          </select>
        </label>
      </div>
    </section>
  );
}
